import React from "react";
import { columnSubheaderGenerator, columnsVisibleType } from "../../../../common/types/search/results";

interface SearchResultsSubheaderRowProps {
	columnsVisible?: columnsVisibleType;
	total?: number;
	columnSubheaderGenerator?: columnSubheaderGenerator;
}

export const SearchResultsSubheaderRow = ({
	columnsVisible,
	total,
	columnSubheaderGenerator,
}: SearchResultsSubheaderRowProps) => {
	if (!columnSubheaderGenerator) {
		return null;
	}

	return (
		<tr className="results-table-subheader">
			{columnSubheaderGenerator(columnsVisible, total)}
		</tr>
	);
};
